import { createUseStyles } from 'react-jss'

import { textEllipsisMultiline } from '../../../../../styles/mixins/text'

export default createUseStyles({
  descriptionText: {
    fontWeight: 400,
    padding: 0,
    width: '100%',
    // textEllipsisMultiline is used instead of textEllipsis because textEllipsis works incorrectly
    // when parent element has display: flexShrink: 1
    ...textEllipsisMultiline(1)
  },
  skeletonDescription: {
    maxWidth: '90%',
    maxHeight: 7,
    height: 7,
    margin: 0
  }
})
